import { mapGetters } from "vuex";
import getData from "@/data/cloud/firebase/mixins/getData.js";

export default {
  // eslint-disable-next-line
  mixins: [getData],
  computed: {
    ...mapGetters(["getUser"])
  },
  methods: {
    selectAccess(data) {
      // console.log("");
      // console.log(">>> Select Access <<<");
      // console.log(data);
      // read user
      let temp = this.getUser;
      if (data.basic.tags === "C1") {
        // console.log("");
        // console.log(">>> Company Selection <<<");
        // get company access limit
        this.getDocumentCompanyAccessOnly(data.select.cdid);

        temp.pref.select = data.select;
        this.$store.dispatch("changeCompanyDID", data.select.cdid);
        this.$store.dispatch("changeUserPref", temp.pref);
      }
      if (data.basic.tags === "F1") {
        // console.log(">>> Facility Selection <<<");
        temp.pref.select.fauth = data.select.fauth; // company tag
        temp.pref.select.ftag = data.select.ftag; // company tag
        temp.pref.select.fname = data.select.fname; // company legal name
        temp.pref.select.fshort = data.select.fshort; // short name
        temp.pref.select.fdid = data.select.fdid;
        temp.pref.select.fidg = data.select.fidg;
        temp.pref.select.fid = data.select.fid;
        // SAVE USER PREF for FACIILITY
        console.log("");
        this.$store.dispatch("changeUserPref", temp.pref);
        // get company access limit
        this.getDocumentFacilityAccessOnly(data.select.fdid);
        this.$store.dispatch("changeFacilityDID", data.select.fdid);
      }
      this.$store.dispatch("changeUser", temp);
      this.enableSpinBtnAccessSelect = false;
      this.dialog = false;
    }
  }
};
